import i18next from "i18next";

export const TranslatedApp = ({ children, resources }) => {
  for (const [key, resource] of Object.entries(resources)) {
    i18next.addResourceBundle(key, "translations", resource, false, false);
  }

  return children;
};
